import { FunctionComponent } from "react";
import { Outlet } from "react-router-dom";

const StudyMaterialWrapper: FunctionComponent = () => {
  return (
    <>
      <Outlet />
    </>
  );
}

export default StudyMaterialWrapper;